<span class="created-by">
  Creado por <b><a href="https://www.innovarts.com.co/" target="_blank">Innovar TS</a></b>, 2020
</span>
<div class="socials">
  <a href="#" target="_blank" class="ion ion-social-facebook"></a>
  <a href="#" target="_blank" class="ion ion-social-instagram"></a>
  <a href="#" target="_blank" class="ion ion-social-twitter"></a>
</div>